import React from "react";
import { Badge, Button, Divider } from "../../../../components";

const BadgeList = () => {
  const colors = [
    "primary",
    "warning",
    "success",
    "danger",
    "info",
    "black",
    "white",
  ];
  const variants = ["contained", "outlined", "text", "dot"];
  const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];
  const anchorPositions = [
    { vertical: "top", horizontal: "right" },
    { vertical: "top", horizontal: "left" },
    { vertical: "center", horizontal: "right" },
    { vertical: "center", horizontal: "left" },
    { vertical: "bottom", horizontal: "right" },
    { vertical: "bottom", horizontal: "left" },
  ];
  const randomValue = () => {
    return Math.floor(Math.random() * (150 - 30 + 1)) + 30;
  };
  return (
    <div className="pt-8 flex flex-col gap-8 overflow-auto flex-1 justify-start">
      <div>
        <Badge value={1} variant={"dot"} size="xs" color="danger">
          <div>
            <Button type="icon" icon={"east"} color="black" />
          </div>
        </Badge>
      </div>
      <div className="flex flex-col gap-8">
        {colors.map((color) => (
          <div className="flex gap-8" key={color}>
            {variants.map((variant) => (
              <Badge
                key={`${color}-${variant}`}
                value={randomValue()}
                max={99}
                color={color}
                variant={variant}
                size="xs-sm"
              >
                <Button
                  title={`Badge-${color}-${variant}`}
                  size="xs-sm"
                  color={color}
                  variant={variant}
                />
              </Badge>
            ))}
          </div>
        ))}
      </div>
      <div className="flex gap-8">
        {anchorPositions.map((position) => (
          <Badge
            key={`${position.vertical}-${position.horizontal}`}
            value={5}
            color="primary"
            anchorOrigin={position}
          >
            <Button
              title={`${position.vertical}-${position.horizontal}`}
              size="xs-sm"
              color="primary"
            />
          </Badge>
        ))}
      </div>
      <div className="flex gap-8">
        {sizes.map((size) => (
          <div key={size}>
            <Badge value={5} color="primary" size={size}>
              <Button title={`size`} size={size} color="primary" />
            </Badge>
          </div>
        ))}
      </div>

      <div className="max-w-6xl">
        <Divider />
        <Divider orientation="vertical" />
        <Divider>Text</Divider>

        <Divider orientation="vertical" />

        <Divider light />
        <Divider orientation="vertical" />
        <Divider textAlign="left">Left Text</Divider>
        <Divider orientation="vertical" />
        <Divider variant="inset" />
        <Divider orientation="vertical" />
        <Divider variant="middle" />
        <Divider orientation="vertical" />
        <Divider className="my-4" />
        <div className="flex gap-2">
          <div>Content 1</div>
          <Divider orientation="vertical" flexItem />
          <div>Content 2</div>
        </div>
      </div>
    </div>
  );
};

export default BadgeList;
